import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import { getConferenceDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import ConferenceDetails from "./ConferenceDetails";
import Sponsors from "./Sponsors";

const Conference = () => {
  const { appState, dispatch } = useContext(AppContext);
  const { conference, conferenceLoader } = appState;
  const myRef = useRef();
  const golf_ref = useRef();

  useEffect(() => {
    getConferenceDetails(appState, dispatch);
  }, []);


  console.log("conference", conference);
  return (
    <>
      {conferenceLoader ? (
        <div className="home-spinner">
          <ClipLoader color={"#2A5350"} loading={true} size={60} />
        </div>
      ) : (
        Object.keys(conference).length && (
          <>
            <Breadcrumb
              pageName={conference.header_services_section.title || "conference" }
              pageTitle={conference.header_services_section.title || "conference" }
              id={`#${conference.header_services_section.title}`}
              image={conference.header_services_section.banner_image}
              myRef={myRef}
            />
            <div ref={myRef}>
              <ConferenceDetails conference={conference} />
            </div>
            {conference.golf_sponsor_section &&
              conference.golf_sponsor_section?.partner_list?.length && (
                <div ref={golf_ref}>
                  <Sponsors
                    sponsor={conference.golf_sponsor_section}
                    index="1"
                    rtl={false}
                  />
                </div>
              )}
            {conference.sponsor_section &&
              conference.sponsor_section?.partner_list?.length && (
                <div ref={myRef}>
                  <Sponsors sponsor={conference.sponsor_section}  rtl={true} index="2" />
                </div>
              )}
          </>
        )
      )}
    </>
  );
};

export default Conference;
